export const FILTER_STATUS_RESOLVED = 0;
export const FILTER_STATUS_PENDING = 1;
export const FILTER_STATUS_LOADING = 2;
